import React, { SyntheticEvent, useEffect, useState } from 'react';
import {
  Grid,
  InputOnChangeData,
} from 'semantic-ui-react';
import { Field } from 'formik';
import SectionLabel from '../../../../../../../../components/SectionLabel';
import { FieldLabel } from '../../../../../../../../styles';
import {
  DATE_INPUT_MASK,
  maskCpfOrCnpj,
  maskPhoneNumber,
  maskZipCode,
} from '../../../../../../../../services/masks';
import Input from '../../../../../../../../components/Input';
import { AddressService } from '../../../../../../../../services/address';
import { getDataByDocument } from '../../../../../../../../services/documents';
import CustomDatePicker from '../../../../../../../../components/CustomDatePicker';
import AppMaskedInput from '../../../../../../../../components/MaskedInput';

const SurtyGeneralInsuranceForm = ({
  values,
  setFieldValue,
  flagSubmit,
  callbackSubmit,
  setFlagSubmit,
  bondInsurance,
  offers,
  maxInstallments,
  nominal_total_premium_amount,
}: any) => {
  const [loadingAddress, setLoadingAddress] = useState(false);
  const [loadingDocument, setLoadingDocument] = useState(false);
  const [offerSelected, setOfferSelected] = useState<any>(null);

  // Seleção automática quando há apenas uma oferta
  useEffect(() => {
    if (offers && offers.length === 1 && !offerSelected) {
      setOfferSelected(offers[0]);
    }
  }, [offers, offerSelected]);

  useEffect(() => {
    if (flagSubmit) {
      // Incluir selectedPlan se houver oferta selecionada
      const payload = {
        ...values,
        selectedPlan: offerSelected ? {
          quantidadeParcela: offerSelected.quantidadeParcela,
          valorParcela: offerSelected.valorParcela,
          nomeSeguro: offerSelected.nomeSeguro,
          id: offerSelected.id,
          codigoOrcamento: offerSelected.codigoOrcamento,
          codigoFormaPagamento: 1, // Fatura
        } : null
      };
      callbackSubmit(payload);
      setFlagSubmit(false);
    }
  }, [flagSubmit, offerSelected]);

  useEffect(() => {
    if (bondInsurance?.estate) {
      setFieldValue('owner_data.zip_code', bondInsurance.estate.estateZipCode || '');
      setFieldValue('owner_data.street', bondInsurance.estate.estateStreet || '');
      setFieldValue('owner_data.district', bondInsurance.estate.estateDistrict || '');
      setFieldValue('owner_data.city', bondInsurance.estate.estateCity || '');
      setFieldValue('owner_data.state', bondInsurance.estate.estateState || '');
      setFieldValue('owner_data.number', bondInsurance.estate.estateNumber || '');
      setFieldValue('owner_data.complement', bondInsurance.estate.estateComplement || '');
    }
  }, [bondInsurance, setFieldValue]);

  const handleZipCodeChange = async (event: any, data: InputOnChangeData) => {
    const maskedValue = maskZipCode(data.value);
    setFieldValue('owner_data.zip_code', maskedValue);

    const zipCode = data.value.replace(/\D/g, '');
    if (zipCode.length === 8) {
      setLoadingAddress(true);
      try {
        const addressData = await AddressService.getAddressByZipCode(zipCode);
        if (addressData) {
          setFieldValue('owner_data.street', addressData.street);
          setFieldValue('owner_data.district', addressData.district);
          setFieldValue('owner_data.city', addressData.city);
          setFieldValue('owner_data.state', addressData.state);
        }
      } catch (error) {
        console.error('Erro ao buscar endereço:', error);
      } finally {
        setLoadingAddress(false);
      }
    }
  };

  const handleDocumentChange = async (event: any, data: InputOnChangeData) => {
    const maskedValue = maskCpfOrCnpj(data.value);
    setFieldValue('owner_data.public_document_id', maskedValue);

    const document = data.value.replace(/\D/g, '');
    if (document.length === 11 || document.length === 14) {
      setLoadingDocument(true);
      try {
        const documentData = await getDataByDocument(document);
        if (documentData) {
          setFieldValue('owner_data.name', documentData.name || '');
          setFieldValue('owner_data.birth_date', documentData.birthDate || '');
        }
      } catch (error) {
        console.error('Erro ao buscar dados do documento:', error);
      } finally {
        setLoadingDocument(false);
      }
    }
  };

  const handleChangeOffer = (offer: any) => {
    setOfferSelected(offer);
  };

  return (
    <div>
      {/* Seção de Seleção de Ofertas */}
      {offers && offers.length > 0 && (
        <>
          <SectionLabel text="Selecionar Plano" />
          <p style={{ color: '#666', marginBottom: '20px' }}>
            {offers.length === 1
              ? "Plano disponível para contratação:"
              : "Selecione o plano que deseja contratar:"
            }
          </p>

          <Grid.Row>
            <Grid.Column width={16}>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                {offers.map((offer: any) => (
                  <div
                    key={offer.id}
                    style={{
                      border: offerSelected?.id === offer.id ? '2px solid #2185d0' : '1px solid #ddd',
                      borderRadius: '8px',
                      padding: '15px',
                      cursor: offers.length > 1 ? 'pointer' : 'default',
                      backgroundColor: offerSelected?.id === offer.id ? '#f0f8ff' : '#fff',
                      position: 'relative',
                    }}
                    onClick={() => offers.length > 1 && handleChangeOffer(offer)}
                  >
                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                      <input
                        type="radio"
                        checked={offerSelected?.id === offer.id}
                        onChange={() => handleChangeOffer(offer)}
                        disabled={offers.length === 1}
                      />
                      <div style={{ flex: 1 }}>
                        <h4 style={{ margin: '0 0 5px 0', color: '#333' }}>
                          {offer.nomeSeguro}
                        </h4>
                        <p style={{ margin: '0', color: '#666', fontSize: '14px' }}>
                          {offer.quantidadeParcela} parcelas de R$ {offer.valorParcela?.toFixed(2)}
                        </p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
              {!offerSelected && offers.length > 1 && (
                <p style={{ color: '#e74c3c', marginTop: '10px', fontSize: '14px' }}>
                  * Para prosseguir, selecione uma das opções a serem contratadas.
                </p>
              )}
            </Grid.Column>
          </Grid.Row>
        </>
      )}

      <SectionLabel text="Dados do Proprietário" />
      <p style={{ color: '#666', marginBottom: '20px' }}>
        Para contratação, os dados do proprietário são obrigatórios.
      </p>

      <Grid width="100%">
        {/* Nome Completo */}
        <Grid.Row>
          <Grid.Column width={8}>
            <FieldLabel>CPF/CNPJ*</FieldLabel>
            <Field
              name="owner_data.public_document_id"
              component={Input}
              value={maskCpfOrCnpj(values.owner_data.public_document_id)}
              placeholder="000.000.000-00"
              onChange={handleDocumentChange}
              loading={loadingDocument}
              fluid
            />
          </Grid.Column>

          <Grid.Column width={8}>
            <FieldLabel>Nome Completo *</FieldLabel>
            <Field name="owner_data.name"
              component={Input}
              placeholder="Nome Completo"
              value={values.owner_data.name}
              onChange={(event: any, data: InputOnChangeData) => {
                setFieldValue('owner_data.name', data.value);
              }}
              fluid
            />
          </Grid.Column>
        </Grid.Row>

        {/* CPF/CNPJ e Data de Nascimento */}
        <Grid.Row>
          <Grid.Column width={6}>
            <FieldLabel>Data de Nascimento *</FieldLabel>
            <Field
              name="owner_data.birth_date"
              component={CustomDatePicker}
              customInput={
                <AppMaskedInput
                  mask={DATE_INPUT_MASK}
                  placeholder="DD/MM/AAAA"
                />
              }
              placeholder="DD/MM/AAAA"
              dateFormat={'dd/MM/yyyy'}
              selected={values.owner_data.birth_date ? new Date(values.owner_data.birth_date) : null}
              onChange={(date: Date, _e: SyntheticEvent) => {
                setFieldValue('owner_data.birth_date', date);
              }}
              fluid
            />
          </Grid.Column>

          {/* Email e Telefone */}
          <Grid.Column width={6}>
            <FieldLabel>Email *</FieldLabel>
            <Field
              name="owner_data.email"
              component={Input}
              placeholder="email@exemplo.com"
              type="email"
              onChange={(event: any, data: InputOnChangeData) => {
                setFieldValue('owner_data.email', data.value);
              }}
              fluid
            />
          </Grid.Column>

          <Grid.Column width={4}>
            <FieldLabel>Telefone *</FieldLabel>
            <Field
              name="owner_data.phone"
              component={Input}
              value={maskPhoneNumber(values.owner_data.phone)}
              placeholder="(00) 00000-0000"
              onChange={(event: any, data: InputOnChangeData) => {
                setFieldValue('owner_data.phone', data.value);
              }}
              fluid
            />
          </Grid.Column>
        </Grid.Row>

        <SectionLabel text="Endereço do Proprietário" />

        {/* CEP e Logradouro */}
        <Grid.Row>
          <Grid.Column width={4}>
            <FieldLabel>CEP *</FieldLabel>
            <Field
              name="owner_data.zip_code"
              component={Input}
              value={maskZipCode(values.owner_data.zip_code)}
              placeholder="00000-000"
              onChange={handleZipCodeChange}
              loading={loadingAddress}
              fluid
            />
          </Grid.Column>

          <Grid.Column width={12}>
            <FieldLabel>Logradouro *</FieldLabel>
            <Field
              name="owner_data.street"
              component={Input}
              placeholder="Nome da rua/avenida"
              onChange={(event: any, data: InputOnChangeData) => {
                setFieldValue('owner_data.street', data.value);
              }}
              fluid
            />
          </Grid.Column>
        </Grid.Row>

        {/* Número e Complemento */}
        <Grid.Row>
          <Grid.Column width={4}>
            <FieldLabel>Número *</FieldLabel>
            <Field
              name="owner_data.number"
              component={Input}
              placeholder="123"
              onChange={(event: any, data: InputOnChangeData) => {
                setFieldValue('owner_data.number', data.value);
              }}
              fluid
            />
          </Grid.Column>

          <Grid.Column width={12}>
            <FieldLabel>Complemento</FieldLabel>
            <Field
              name="owner_data.complement"
              component={Input}
              placeholder="Apartamento, sala, etc."
              onChange={(event: any, data: InputOnChangeData) => {
                setFieldValue('owner_data.complement', data.value);
              }}
              fluid
            />
          </Grid.Column>
        </Grid.Row>

        {/* Bairro, Cidade e Estado */}
        <Grid.Row>
          <Grid.Column width={6}>
            <FieldLabel>Bairro *</FieldLabel>
            <Field
              name="owner_data.district"
              component={Input}
              placeholder="Nome do bairro"
              onChange={(event: any, data: InputOnChangeData) => {
                setFieldValue('owner_data.district', data.value);
              }}
              fluid
            />
          </Grid.Column>

          <Grid.Column width={8}>
            <FieldLabel>Cidade *</FieldLabel>
            <Field
              name="owner_data.city"
              component={Input}
              placeholder="Nome da cidade"
              onChange={(event: any, data: InputOnChangeData) => {
                setFieldValue('owner_data.city', data.value);
              }}
              fluid
            />
          </Grid.Column>

          <Grid.Column width={2}>
            <FieldLabel>Estado *</FieldLabel>
            <Field
              name="owner_data.state"
              component={Input}
              placeholder="UF"
              maxLength={2}
              onChange={(event: any, data: InputOnChangeData) => {
                setFieldValue('owner_data.state', data.value.toUpperCase());
              }}
              fluid
            />
          </Grid.Column>
        </Grid.Row>
      </Grid>

      <SectionLabel text="Datas do Seguro" />
      <p style={{ color: '#666', marginBottom: '20px' }}>
        Informe as datas de início e fim do contrato do seguro.
      </p>

      <Grid width="100%">
        {/* Data de Início e Fim do Contrato do Seguro */}
        <Grid.Row>
          <Grid.Column width={8}>
            <FieldLabel>Data de Início do Contrato do Seguro *</FieldLabel>
            <Field
              name="rent_insurance_contract_start_date"
              component={CustomDatePicker}
              customInput={
                <AppMaskedInput
                  mask={DATE_INPUT_MASK}
                  placeholder="DD/MM/AAAA"
                />
              }
              dateFormat={'dd/MM/yyyy'}
              selected={values.rent_insurance_contract_start_date ? new Date(values.rent_insurance_contract_start_date) : null}
              onChange={(date: Date, _e: SyntheticEvent) => {
                setFieldValue('rent_insurance_contract_start_date', date);
              }}
              fluid
            />
          </Grid.Column>

          <Grid.Column width={8}>
            <FieldLabel>Data de Fim do Contrato do Seguro *</FieldLabel>
            <Field
              name="rent_insurance_contract_end_date"
              component={CustomDatePicker}
              customInput={
                <AppMaskedInput
                  mask={DATE_INPUT_MASK}
                  placeholder="DD/MM/AAAA"
                />
              }
              dateFormat={'dd/MM/yyyy'}
              selected={values.rent_insurance_contract_end_date ? new Date(values.rent_insurance_contract_end_date) : null}
              onChange={(date: Date, _e: SyntheticEvent) => {
                setFieldValue('rent_insurance_contract_end_date', date);
              }}
              fluid
            />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </div>
  );
};

export default SurtyGeneralInsuranceForm;